import { userFields } from './users';

const submissionFields = {
  CARDS_SENT: 'Total # Sent',
  COUPON_CODE: 'Coupon code',
  DATE_SENT: 'Date Sent',
  NO_RETURN_SHIPPING: 'No Return Shipping',
  STRIPE_ID: 'Stripe ID',
  SUBMISSION_NUMBER: 'Submission Number',
  TRACKING_NUMBER: 'Tracking Number',
  USER_ID: userFields.USER_ID,
  USER_NAME: userFields.USER_NAME,
};

const submissionCardsFields = {
  CARD_NAME: 'Card Name',
  CARD_NUMBER: 'Card Number',
  DECLARED_VALUE: 'Declared Value',
  DESTINATION: 'Destination',
  HARD_CASE: 'Hard Case',
  PREP: 'Prep',
  SERVICE_LEVEL: 'Service Level',
  SET: 'Set',
  SUBMISSION: 'Submission',
  SUBMISSION_NUMBER: 'Submission Number (from Submission)',
  YEAR: 'Year',
};

export {
  submissionCardsFields,
  submissionFields,
};
